module.exports = {
      id: "jokes-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#jokes",
      toString: function () {
        return this.url;
      }
    }